import React from 'react';
import classNames from 'classnames';
import { isMobileUA } from '~/utils';

interface PersonaCollectItemProps {
    className?: string;
    title: React.ReactNode;
    children: React.ReactNode;
}

const PersonaCollectItem: React.FC<PersonaCollectItemProps> = (props) => {
    const { className, title, children } = props;

    return (
        <div
            className={classNames('fx-persona-collect-item', className, {
                'is-mobile': isMobileUA()
            })}
        >
            <div className="item-title">{title}</div>
            {children}
        </div>
    );
};

export default PersonaCollectItem;
